import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data"];
import { useMemo } from 'react';
import { useGetAiAgentProfilesForPortalQuery } from '../../../__generated__/chirp/com/hubspot/cv/ai/agents/configuration/rpc/AiAgentService.hooks';
export const useHasConfiguredCustomerAgent = () => {
  const _useGetAiAgentProfile = useGetAiAgentProfilesForPortalQuery(),
    {
      data
    } = _useGetAiAgentProfile,
    rest = _objectWithoutPropertiesLoose(_useGetAiAgentProfile, _excluded);
  const hasConfiguredAgent = useMemo(() => {
    return data ? data.results.length > 0 : undefined;
  }, [data]);
  return Object.assign({
    hasConfiguredAgent
  }, rest);
};